import './toggleSwitch.scss';

type ToggleSwitchProps = {
  label?: string;
  checked: boolean;
  disabled?: boolean;
  onToggle: () => void;
};

const ToggleSwitch = ({ label, checked, disabled = false, onToggle }: ToggleSwitchProps) => {
  return (
    <div className={`toggle-switch-container${disabled ? ' toggle-switch-container--disabled' : ''}`}>
      {label && <label>{label}</label>}
      <div className="toggle-switch">
        <label className="switch">
          <input type="checkbox" checked={checked} disabled={disabled} onChange={onToggle} />
          <span className="slider round"></span>
        </label>
      </div>
    </div>
  );
};

export default ToggleSwitch;
